import PropTypes from 'prop-types';
import React from 'react';


/**
 * The Toolbar components renders tools for a given process
 */
export default class Toolbar extends React.Component {

    static propTypes = {
        children: PropTypes.any, // children may be an array of objects or a single object
        className: PropTypes.string,
        selectedItems: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        lastSelectedItem: PropTypes.string

    };

    render() {
        const className = this.props.className ? `${this.props.className} toolbar` : 'toolbar';
        return (
            <div className={className}>
                {/* Pass my selected items down to my children */}
                {React.Children.map(this.props.children,
                    (child) => {
                        if (child) {
                            return React.cloneElement(child, {
                                selectedItems: this.props.selectedItems,
                                lastSelectedItem: this.props.lastSelectedItem
                            });
                        } else {
                            return null;
                        }
                    }
                )}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/toolbar/Toolbar.js